import React from "react";
import Page from "../templates/support/wellbing/spotlight/undp-backyard-poultry-and-market";

function spotlight() {
  return (
    <div>
      <Page />
    </div>
  );
}

export default spotlight;
